import { useEffect, useState } from 'react';
import { List, Modal, Tag } from 'antd';
import { pcompany, ptax } from '@/proto/proto';
import { Button, Col, Row, Text, Title } from '@/components/atoms';
import {
  API_TAX_NOTICE_INFO,
  FORMAT_DATE_GENERAL_EXCEPT_SECOND,
  IMAGE_PATH_TAX_CHANGE,
  IMAGE_PATH_TAX_CONTRACT,
  IMAGE_PATH_TAX_NOTICE,
} from '@/constants/constant';
import moment from 'moment';
import { messageOf } from '@/components/covalent/tax/change/TaxChangeStatus';
import { nameOf } from '@/components/covalent/tax/change/TaxChangeType';
import api from '@/api';

type TaxChangeInformationModalProps = {
  taxNotice?: ptax.IPbTaxNotice;
  taxChangeRequest?: ptax.IPbTaxChangeRequest;
  company: pcompany.IPbCompany;
  visible: boolean;
  onCancel: () => void;
};

const TaxChangeInformationModal = ({ taxNotice, taxChangeRequest, company, visible, onCancel }: TaxChangeInformationModalProps) => {
  const [data, setData] = useState<ptax.IPbTaxNotice>();

  useEffect(() => {
    const taxNoticeId = Number(taxChangeRequest?.taxNoticeId ?? -1);
    if (taxNoticeId > 0) {
      api.get(API_TAX_NOTICE_INFO(taxNoticeId)).then((response) => {
        setData(response.data);
      });
    }
  }, [taxChangeRequest]);

  return (
    <Modal title="민원 정보" visible={visible} onCancel={onCancel} footer={null}>
      <Title>등록파일</Title>
      <Row justify="space-between">
        <Text>
          <Tag>고지서</Tag>
          {(taxNotice ?? data)?.fileOrgName}
        </Text>
        <Button type="default">
          <a href={IMAGE_PATH_TAX_NOTICE(Number(company?.base?.id), taxNotice ?? data)}>다운로드</a>
        </Button>
      </Row>
      <Row justify="space-between">
        <Text>
          <Tag>계약서</Tag>
          {(taxNotice ?? data)?.contractFileOrgName}
        </Text>
        <Button type="default">
          <a href={IMAGE_PATH_TAX_CONTRACT(Number(company?.base?.id), taxNotice ?? data)}>다운로드</a>
        </Button>
      </Row>
      <Row justify="space-between">
        <Text>
          <Tag>신청서</Tag>
          {(taxNotice ?? data)?.changeFileOrgName}
        </Text>
        <Button type="default">
          <a href={IMAGE_PATH_TAX_CHANGE(Number(company?.base?.id), taxNotice ?? data)}>다운로드</a>
        </Button>
      </Row>
      <Title>신청내역</Title>
      <List
        header={
          <Row>
            <Col span={8} style={{ justifyContent: 'center' }}>
              <Text>일시</Text>
            </Col>
            <Col span={4} style={{ justifyContent: 'center' }}>
              <Text>실행내용</Text>
            </Col>
            <Col span={12} style={{ justifyContent: 'center' }}>
              <Text>부가정보</Text>
            </Col>
          </Row>
        }
        dataSource={(taxNotice ?? data)?.changeRequest ?? []}
        renderItem={(item: ptax.IPbTaxChangeRequest) => {
          return (
            <Row style={{ padding: '12px 0' }}>
              <Col span={8} style={{ justifyContent: 'center' }}>
                <Text>{moment(item.base?.createdAt).format(FORMAT_DATE_GENERAL_EXCEPT_SECOND)}</Text>
              </Col>
              <Col span={4} style={{ justifyContent: 'center' }}>
                <Text>{messageOf(Number(item.statusCode))}</Text>
              </Col>
              <Col span={12} style={{ justifyContent: 'center' }}>
                <Text>{nameOf(Number(item.typeCode))}</Text>
              </Col>
            </Row>
          );
        }}
      />
    </Modal>
  );
};

TaxChangeInformationModal.defaultProps = {
  taxNotice: undefined,
  taxChangeRequest: undefined,
};

export default TaxChangeInformationModal;
